import exclusionsUrl from './images/exclusions.png';
import factsUrl from './images/facts.png';
import highlightsUrl from './images/highlights.png';
import inclusionsUrl from './images/inclusions.png';
import suitcase from './images/suitcase.png';

export const LIST_PLACEHOLDER_IMAGE_TYPE = {
  HIGHLIGHTS: 'highlights',
  FACTS: 'facts',
  INCLUSIONS: 'inclusions',
  EXCLUSIONS: 'exclusions',
  SUITCASE: 'suitcase',
};

const { HIGHLIGHTS, FACTS, INCLUSIONS, EXCLUSIONS, SUITCASE } = LIST_PLACEHOLDER_IMAGE_TYPE;

export const LIST_CONFIG = {
  [HIGHLIGHTS]: {
    img: highlightsUrl,
  },
  [FACTS]: {
    img: factsUrl,
  },
  [INCLUSIONS]: {
    img: inclusionsUrl,
  },
  [EXCLUSIONS]: {
    img: exclusionsUrl,
  },
  [SUITCASE]: {
    img: suitcase,
  },
};

export function getDefaultListItem(key: string) {
  const item = LIST_CONFIG[key];

  if (!item) {
    return LIST_CONFIG[SUITCASE];
  }

  return item;
}
